var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 213,
    viewBox: "0 0 213 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.003 106.562C213.036 129.368 205.723 151.579 192.149 169.898C191.778 170.415 191.391 170.915 190.988 171.415C190.585 171.916 190.52 172.029 190.294 172.303C189.504 173.32 188.681 174.321 187.859 175.305C187.036 176.29 186.246 177.242 185.343 178.178C184.778 178.808 184.214 179.437 183.617 180.051L181.827 181.875L180.004 183.666L179.085 184.506C167.643 195.147 154.002 203.138 139.128 207.911C124.254 212.685 108.513 214.124 93.021 212.127C77.5292 210.13 62.6664 204.745 49.4872 196.355C36.308 187.964 25.1354 176.774 16.762 163.578C8.38866 150.382 3.01977 135.504 1.03629 119.998C-0.947185 104.493 0.503356 88.7408 5.285 73.8594C10.0666 58.978 18.0622 45.3321 28.7044 33.8898C39.3466 22.4476 52.3746 13.4894 66.864 7.65094V7.65094C79.4691 2.57137 92.9351 -0.0263634 106.524 0.000201703C107.878 0.000201703 109.217 0.000201709 110.572 0.0970465C117.209 0.327923 123.808 1.19269 130.281 2.67957V2.67957C138.855 4.64173 147.154 7.65596 154.989 11.6539V11.6539C172.459 20.5871 187.123 34.1781 197.36 50.9263C207.598 67.6745 213.011 86.9283 213.003 106.562V106.562Z",
    fill: "#E9F1F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.405 37.2351C160.408 37.2512 160.407 37.2676 160.402 37.2833C160.397 37.2989 160.389 37.3133 160.379 37.3256C160.368 37.3379 160.355 37.3477 160.34 37.3543C160.325 37.361 160.309 37.3644 160.293 37.3642C159.551 37.3642 155.583 37.3642 154.728 35.4757C153.791 33.6449 152.361 32.113 150.599 31.0531C148.857 29.891 146.406 21.9336 144.567 25.6621C144.258 26.3137 144.169 27.0478 144.311 27.7547C144.453 28.4616 144.821 29.1035 145.358 29.5843C145.464 29.6545 145.553 29.7476 145.619 29.8568C145.685 29.966 145.725 30.0884 145.738 30.2153C145.75 30.3422 145.734 30.4702 145.69 30.59C145.647 30.7098 145.577 30.8184 145.487 30.9079C144.648 32.0377 143.6 32.0055 141.777 32.522C139.955 33.0385 138.551 41.1734 140.164 40.8183C141.777 40.4632 143.825 38.9783 146.083 39.753C148.341 40.5278 157.373 46.0157 154.244 48.3561C153.696 48.7757 149.599 44.5953 148.277 44.1756C147.374 43.8689 149.39 47.0325 149.696 48.0171C150.752 50.9534 151.048 54.1094 150.558 57.1911C150.067 60.2729 148.805 63.1804 146.89 65.6429C145.712 67.3538 151.003 69.1938 150.809 71.5665C150.615 73.9392 149.196 76.7154 147.858 76.2474C146.519 75.7793 147.729 72.0992 145.841 71.0823C143.954 70.0654 140.568 66.0625 139.084 68.3222C137.6 70.5819 135.761 76.0052 137.955 77.1997C140.148 78.3941 143.567 78.4425 144.293 83.656C145.019 88.8695 139.31 104.413 131.39 106.608C123.471 108.803 124.1 111.079 126.778 113.5C129.455 115.921 134.406 123.185 128.552 127.301C122.697 131.417 122.971 125.687 119.085 124.347C115.198 123.007 114.778 128.689 117.31 131.433C119.843 134.177 124.907 136.824 124.778 140.036C124.649 143.248 123.165 141.957 120.939 141.02C118.714 140.084 119.036 137.163 115.843 135.032C112.649 132.902 114.117 127.914 112.117 124.089C110.117 120.263 106.569 121.232 104.053 118.746C101.537 116.26 103.521 113.097 100.73 110.127C97.9403 107.157 92.1018 105.107 89.3439 109.949C87.0729 114.019 83.768 117.415 79.7636 119.795C76.6993 121.571 80.9733 126.252 78.3605 129.77C77.3194 131.251 75.9923 132.508 74.4574 133.466C74.3417 133.531 74.2135 133.569 74.0816 133.579C73.9498 133.589 73.8173 133.57 73.6933 133.524C73.5693 133.478 73.4566 133.406 73.3631 133.312C73.2695 133.219 73.1971 133.106 73.151 132.982C71.6672 129.205 66.1836 114.727 66.6997 109.352C67.2964 103.138 51.9906 102.153 46.7973 98.7315C41.604 95.3096 37.7332 84.3177 36.1042 85.5929C34.4752 86.868 34.6365 99.8129 38.1041 99.6354C39.9878 99.5018 41.8809 99.6213 43.7329 99.9905V99.9905C44.0232 100.378 48.0876 105.753 43.8942 109.675C39.7008 113.597 27.8465 118.036 25.8627 116.406C23.8789 114.775 24.766 87.3522 22.3951 85.2216C20.0242 83.091 20.5726 100.362 20.5726 104.203C20.5726 108.045 21.5403 117.503 23.3144 118.52C25.0885 119.537 32.2334 123.282 33.314 121.442C34.3946 119.602 33.1366 135.968 24.2176 141.488C15.2986 147.009 26.7659 164.65 28.04 167.927C29.0238 170.461 29.8948 177.612 30.4754 180.743C30.556 181.179 30.4754 181.13 30.1367 180.743C20.299 170.619 12.5707 158.64 7.40112 145.5C2.23155 132.361 -0.276067 118.324 0.0240874 104.206C0.324242 90.0875 3.42618 76.1699 9.14951 63.2624C14.8728 50.3548 23.1033 38.7149 33.3624 29.0194V29.0194C33.6688 28.9064 62.3934 18.7054 64.7481 21.4655C67.1029 24.2256 60.2161 31.5374 64.7481 30.5044C69.2802 29.4713 77.2476 26.34 79.2637 28.0671C81.2797 29.7942 83.4409 27.0018 87.3278 25.8074C91.2148 24.613 100.231 21.1104 100.537 20.9652C105.727 21.6819 110.991 21.6819 116.181 20.9652C123.568 19.7707 134.439 11.7326 139.439 13.3951C144.438 15.0576 147.793 16.3327 149.212 19.1574C150.632 21.982 149.309 23.8705 150.712 25.3877C152.115 26.905 154.277 28.3576 155.809 30.004C157.341 31.6504 159.97 35.3143 160.405 37.2351Z",
    fill: "url(#paint0_linear_757_1231)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.196 52.0214C155.196 52.0214 157.18 53.9583 156.583 54.9429C155.986 55.9275 157.244 59.0588 157.841 59.5915C158.427 60.3553 158.803 61.2588 158.933 62.2127C159.063 63.1666 158.943 64.1379 158.583 65.0309C157.518 67.2906 157.583 69.2114 156.26 70.196C154.938 71.1805 152.341 74.7154 153.47 76.3779C154.599 78.0404 155.631 80.6229 156.115 79.9611C156.599 79.2994 155.793 76.4424 156.986 74.4571C158.18 72.4718 160.76 71.7293 162.357 69.4696C163.064 68.6223 163.504 67.5844 163.621 66.487C163.739 65.3896 163.529 64.282 163.018 63.3038C162.083 61.2378 159.615 57.8644 158.438 57.7998C157.26 57.7353 157.357 56.9928 158.438 56.1858C159.518 55.3787 160.228 56.3149 160.696 54.3296C161.163 52.3442 160.502 52.8607 160.034 51.4081C159.567 49.9554 158.583 51.8116 157.18 51.4081C155.777 51.0046 155.067 50.3589 155.196 52.0214Z",
    fill: "url(#paint1_linear_757_1231)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.1 139.731C134.294 141.458 133.374 144.218 135.1 146.074C136.826 147.931 145.132 150.804 147.1 148.721C149.067 146.639 148.938 140.651 150.793 139.037C152.648 137.423 148.825 134.663 149.116 132.565C149.406 130.466 147.745 127.028 145.664 128.529C143.584 130.03 142.31 135.68 140.003 136.955C137.697 138.23 135.1 139.731 135.1 139.731Z",
    fill: "url(#paint2_linear_757_1231)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.196 134.387C172.55 131.498 175.776 136.76 177.647 134.387C180.776 130.578 190.179 130.691 192.291 133.628C193.904 135.823 193.388 138.47 195.42 139.503C197.453 140.537 198.178 141.715 195.42 142.264C192.662 142.812 191.195 137.308 189.163 140.068C188.536 141.122 187.649 141.996 186.587 142.607C185.525 143.218 184.323 143.544 183.098 143.555C180.34 143.926 183.098 140.988 181.631 139.875C180.163 138.761 174.97 140.424 174.05 138.777C173.131 137.131 169.663 137.68 171.196 134.387Z",
    fill: "url(#paint3_linear_757_1231)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192.13 169.962C192.13 169.962 194.775 163.505 193.743 160.277C192.711 157.049 187.292 150.98 187.292 147.784C187.292 144.588 185.582 146.993 185.324 151.303C185.066 155.613 185.066 158.453 182.743 158.147C180.421 157.84 179.518 155.257 178.873 153.111C178.227 150.964 172.421 149.237 171.115 153.111C169.808 156.985 160.696 166.685 155.615 169.897C150.535 173.109 142.455 173.448 143.745 180.082C145.035 186.716 146.584 190.428 145.89 190.945C145.197 191.461 145.455 192.559 150.019 190.073C154.583 187.587 168.937 178.871 170.76 181.373C171.689 182.642 172.969 183.612 174.442 184.162C175.915 184.713 177.517 184.821 179.05 184.472C183.845 180.046 188.223 175.189 192.13 169.962Z",
    fill: "url(#paint4_linear_757_1231)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4431 166.685C33.4431 166.685 36.6688 164.765 36.6688 163.247C36.6688 161.73 37.3945 162.796 38.7171 165.297C40.0396 167.799 39.4428 168.719 40.088 171.883C40.7331 175.046 42.862 179.469 42.1363 179.792C41.4105 180.115 36.6688 177.677 35.8785 174.594C35.0882 171.512 35.4269 171.576 33.8463 169.542C32.2657 167.509 32.5399 167.428 33.4431 166.685Z",
    fill: "url(#paint5_linear_757_1231)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5539 133.049C79.5539 134.986 78.7152 139.505 80.9248 138.246C83.1344 136.987 82.5376 136.632 82.086 135.147C81.5038 133.866 80.8356 132.626 80.0861 131.435C79.7636 130.709 79.6184 131.693 79.5539 133.049Z",
    fill: "url(#paint6_linear_757_1231)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.134 139.232C105.134 139.232 114.359 147.302 114.44 148.642C114.52 149.981 125.407 157.6 126.955 157.051C128.504 156.502 128.568 153.387 127.858 151.935C127.149 150.482 119.794 147.722 118.649 146.721C117.002 145.272 115.256 143.94 113.424 142.734C111.601 141.669 105.94 137.327 105.134 139.232Z",
    fill: "url(#paint7_linear_757_1231)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.681 156.58C131.471 156.451 132.568 155.37 133.294 154.482C134.019 153.594 138.132 155.128 140.971 154.886C143.809 154.644 153.873 153.449 155.486 153.126C157.099 152.803 158.938 152.174 159.341 153.126C159.744 154.079 153.648 157.468 149.664 157.065C145.68 156.661 134.116 157.936 131.681 156.58Z",
    fill: "url(#paint8_linear_757_1231)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.569 0.0969886C110.569 0.435945 104.618 2.14687 101.989 3.05075C98.6017 4.22903 94.2148 4.06762 92.86 5.601C91.5052 7.13437 85.9248 8.65161 82.5378 8.4902C79.1509 8.32879 68.1513 11.1857 65.7805 11.5085C63.4096 11.8313 66.5869 8.02212 66.8933 7.65088C79.4883 2.57538 92.943 -0.0222689 106.521 0.000143804C107.875 0.000143804 109.214 0.0162846 110.569 0.0969886Z",
    fill: "url(#paint9_linear_757_1231)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154.696 11.9929C154.212 13.1551 151.083 13.0098 149.212 13.1389C147.341 13.268 143.116 8.29668 142.164 8.79705C141.213 9.29741 137.568 8.89389 135.423 8.79705C133.568 8.76477 130.874 4.24534 130.132 2.93794C130.119 2.91183 130.112 2.88279 130.113 2.85344C130.113 2.82409 130.121 2.79533 130.136 2.76974C130.15 2.74415 130.17 2.72253 130.195 2.70682C130.22 2.6911 130.248 2.68178 130.278 2.67969V2.67969C139.1 4.45517 150.196 8.66792 154.664 11.9929H154.696Z",
    fill: "url(#paint10_linear_757_1231)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8464 141.811L28.7978 136.969C29.1204 137.308 25.1367 140.552 25.298 140.714L27.814 138.277",
    fill: "url(#paint11_linear_757_1231)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7634 119.763C80.215 120.215 87.8276 111.338 88.134 111.693C88.4405 112.048 81.2956 117.681 81.9085 118.311C83.5998 116.845 85.2148 115.294 86.747 113.662C86.747 113.662 82.5214 117.423 82.7472 117.665C82.7472 117.665 85.8761 114.163 86.1019 114.437",
    fill: "url(#paint12_linear_757_1231)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_757_1231",
    x1: 0,
    y1: 97.1107,
    x2: 160.407,
    y2: 97.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_757_1231",
    x1: 153.193,
    y1: 65.4553,
    x2: 163.653,
    y2: 65.4553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_757_1231",
    x1: 134.121,
    y1: 138.804,
    x2: 151.303,
    y2: 138.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_757_1231",
    x1: 170.81,
    y1: 137.529,
    x2: 197.227,
    y2: 137.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_757_1231",
    x1: 143.607,
    y1: 168.976,
    x2: 193.982,
    y2: 168.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_757_1231",
    x1: 32.7126,
    y1: 171.184,
    x2: 42.2852,
    y2: 171.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_757_1231",
    x1: 79.3977,
    y1: 134.827,
    x2: 82.5151,
    y2: 134.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_757_1231",
    x1: 105.134,
    y1: 147.917,
    x2: 128.293,
    y2: 147.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_757_1231",
    x1: 131.655,
    y1: 154.922,
    x2: 159.36,
    y2: 154.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_757_1231",
    x1: 64.9077,
    y1: 5.76396,
    x2: 110.569,
    y2: 5.76396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_757_1231",
    x1: 130.113,
    y1: 7.91054,
    x2: 154.696,
    y2: 7.91054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_757_1231",
    x1: 23.8464,
    y1: 139.39,
    x2: 28.8164,
    y2: 139.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_757_1231",
    x1: 79.7634,
    y1: 115.731,
    x2: 88.1436,
    y2: 115.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D8CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsia);
export default __webpack_public_path__ + "static/media/asia.4fece773d5ca4a95e5217527bf118ec1.svg";
export { ForwardRef as ReactComponent };